import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { IncidentTypeResponse } from '../../../shared/interfaces/incident-type-response.interface';
import { TicketService } from '../../../shared/services/ticket.service';

@Component({
  selector: 'app-help-modal-button',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterLink],
  templateUrl: './help-modal-button.component.html',
  styleUrl: './help-modal-button.component.scss'
})
export class HelpModalButtonComponent implements OnInit {
  private ticketService = inject(TicketService);

  showHelpBox2 = false;
  showThxBox2 = false;
  selectedFile: File | null = null;
  fileName: string = '';
  incidentTypes: IncidentTypeResponse[] = [];
  helpData = {
    duda: '',
    comentarios: ''
  };

  ngOnInit() {
    this.loadIncidentTypes();
  }

  loadIncidentTypes() {
    this.ticketService.getCatIncidentsType()
      .subscribe({
        next: (response) => {
          this.incidentTypes = response;
        },
        error: (error) => {
          console.error('Error al cargar tipos de incidentes:', error);
        }
      });
  }

  openHelpBox2() {
    setTimeout(() => {
      const backdrop = document.querySelector('.modal-backdrop');
      if (backdrop) {
        backdrop.remove();
      }
      document.body.classList.remove('modal-open');
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';

      this.showHelpBox2 = true;
      this.showThxBox2 = false;
      console.log('Help box 2 abierto:', this.showHelpBox2);
    }, 400);
  }

  closeHelpBox2() {
    this.showHelpBox2 = false;
    this.showThxBox2 = false;
    this.helpData = { duda: '', comentarios: '' };
    this.selectedFile = null;
    this.fileName = '';
  }

  triggerFileInput() {
    const input = document.getElementById('real-input') as HTMLInputElement;
    if (input) {
      input.click();
    }
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      this.selectedFile = input.files[0];
      this.fileName = this.selectedFile.name;
    }
  }

  sendHelp2() {
    if (!this.helpData.duda || !this.helpData.comentarios) {
      return;
    }
    this.ticketService.createTicket(
      this.helpData.duda,
      this.helpData.comentarios,
      this.selectedFile || undefined
    ).subscribe({
      next: (response) => {
        console.log('Ticket creado exitosamente:', response);
        this.showThxBox2 = true;
      },
      error: (error) => {
        console.error('Error al crear ticket:', error);
        alert('Hubo un error al enviar tu solicitud. Por favor, intenta nuevamente.');
      }
    });
  }
}
